<template>
  <v-app id="app">
    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        :color="$vuetify.theme.dark ? '#0d2137' : '#0072AC'" dark app flat
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down"><strong>Yaku</strong>SeLA</span> <small> - CAJAS</small>
      </v-toolbar-title>
      <v-spacer/>

      <v-btn icon @click="toggleDarkMode()" :title="$vuetify.theme.dark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
        <v-icon>{{ $vuetify.theme.dark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <v-btn icon @click="logout()" title="Salir del sistema">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
        v-if="isLogin"
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="indigo">
            <img src="./assets/yaku-user.png" alt="foto"/>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title><small>Usuario: {{ usuario.email }}</small></v-list-item-title>
          <v-list-item-subtitle>Ventanilla: <strong>{{ usuario.cajero.ventanilla }}</strong></v-list-item-subtitle>
          <v-list-item-subtitle>{{ usuario.cajero.entidad }} | {{ usuario.cajero.sucursal }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list>
        <div v-for="(section, i) in menu" :key="i">
          <v-subheader>{{ section.header.toUpperCase() }}</v-subheader>
          <v-list-item-group color="primary">
            <div v-for="(link, j) in menu[0].links" :key="j">
              <v-list-item dense link exact :to="link.url" color="primary" v-if="globalService.can(link.can)">
                <v-list-item-icon>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ link.label }}
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-item-group>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="abrirManual" dark block class="mb-2">
            <v-icon>mdi-file</v-icon>
            Manual de Usuario
          </v-btn>
          <v-btn @click="logout" color="#0072AC" dark block>
            <v-icon>mdi-apps</v-icon>
            Aplicaciones
          </v-btn>
        </div>
      </template>

    </v-navigation-drawer>

    <v-main>
      <v-container class="fill-height" fluid grid-list-xl :style="{ backgroundColor: $vuetify.theme.dark ? '#121212' : '#efefef' }">
        <v-layout justify-center wrap>
          <v-flex md12>
            <router-view :key="$route.fullPath"></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import menu from './jsons/menu.json';
import {Alert} from "@/addons/Alert";
import {globalStore} from "@/store/globalStore";
import {GlobalService} from "@/services/GlobalService";
import {UserAuth} from "@/models/UserAuth";

@Component({
  name: 'App'
})
export default class App extends Vue {
  globalStore = globalStore();
  globalService = GlobalService.getInstance();

  menu = menu;
  drawer = true;

  get isLogin() {
    this.globalService.checkLogin();
    return this.globalStore.isLogin;
  }

  get urlYakusela() {
    return this.globalStore.urlYakusela;
  }

  get usuario(): UserAuth {
    return this.globalStore.user;
  }

  mounted() {
    if (this.isLogin) {
      this.globalService.getUsuario();
      this.globalService.getPermisos();
      this.globalService.getFecha();
    }
  }

  toggleDarkMode() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    localStorage.setItem('darkMode', String(this.$vuetify.theme.dark));
  }

  logout() {
    Alert.confirm("¿Seguro que quiere salir del módulo?").then(res => {
      if (res.isConfirmed) {
        this.salirDelSistema();
      }
    })
  }

  salirDelSistema() {
    this.globalService.destroyToken().then(() => {
      window.location.href = this.urlYakusela;
    })
  }

  abrirManual() {
    window.open(
        "/ManualUsuario.pdf", "_blank");
  }
}
</script>

<style scope>
.router-link-active {
  font-weight: bold;
}

/* ── Modo oscuro: filas de v-data-table ─────────────────────────── */
.theme--dark.v-data-table,
.theme--dark .v-data-table__wrapper,
.theme--dark.v-data-table tbody tr {
  background-color: #1E1E1E;
}
.theme--dark.v-data-table tbody tr:nth-child(even) {
  background-color: #252525;
}
.theme--dark.v-data-table tbody tr:hover {
  background-color: #2C2C2C !important;
}

/* ── Modo oscuro: v-simple-table (tablas manuales) ──────────────── */
.theme--dark .v-data-table__wrapper table,
.theme--dark.v-simple-table {
  background-color: #1E1E1E;
}
.theme--dark .v-simple-table__wrapper tr:nth-child(even),
.theme--dark .v-data-table__wrapper tbody tr:nth-child(even) {
  background-color: #252525;
}
</style>

